/**
 * Syma Collection Filters
 * Filtros nativos: marca (vendor), faixa de preço e atributos de metafields.
 */
(function () {
  'use strict';

  var P = 'fa_';

  // ─── Mapa: chave de metafield → [label, grupo] ────────────────────────────
  var META = {
    marca:['Marca','Geral'], voltagem:['Voltagem','Geral'],
    conexao:['Conexão','Tipo'], iluminacao:['Iluminação','Geral'],
    linha:['Linha','Tipo'],
    sistema_operacional:['Sistema Operacional','Notebook / PC'],
    processador:['Processador','Notebook / PC'],
    geracao_processador_maquina:['Geração do Processador','Notebook / PC'],
    memoria_ram:['Memória RAM','Notebook / PC'],
    tipo_armazenamento:['Tipo de Armazenamento','Notebook / PC'],
    armazenamento:['Armazenamento','Notebook / PC'],
    tamanho_de_tela:['Tamanho de Tela','Notebook / PC'],
    tipo_de_tela:['Tipo de Tela','Notebook / PC'],
    resolucao_tela_notebook:['Resolução de Tela','Notebook / PC'],
    cpu_placamae:['CPU Compatível','Placa Mãe'],
    socket_placamae:['Socket','Placa Mãe'],
    slot_memoria_placamae:['Slots de Memória','Placa Mãe'],
    geracao_placamae:['Geração','Placa Mãe'],
    ddr_placamae:['Tipo de Memória','Tipo de Memória'],
    formato_placamae:['Formato da Placa','Formato da Placa'],
    modelo_processador:['Modelo','Processador'],
    geracao_processador:['Geração','Processador'],
    plataforma_processador:['Plataforma','Plataforma'],
    vga_integrado_processador:['VGA Integrado','VGA Integrado'],
    capacidade_memoria:['Quantidade de Memória','Memória RAM'],
    frequencia_memoria:['Frequência','Memória RAM'],
    tipo_memoria:['Tipo DDR','Memória RAM'],
    formato_memoria:['Compatibilidade','Memória RAM'],
    capacidade_hdessd:['Armazenamento','Armazenamento'],
    compatibilidade_ssd:['Compatibilidade','Armazenamento'],
    nvme_ssd:['NVMe','Armazenamento'],
    chipset_placadevideo:['Chipset','Placa de Vídeo'],
    modelo_placadevideo:['Modelo','Placa de Vídeo'],
    memoria_placadevideo:['Memória VRAM','Placa de Vídeo'],
    gddr_placadevideo:['Tipo de Memória','Placa de Vídeo'],
    tipo_placadevideo:['Tipo Placa de Vídeo','Tipo Placa de Vídeo'],
    tipo_gabinete:['Tipo','Gabinete'],
    gabinete_inclui_cooler:['Inclui Cooler','Gabinete'],
    potencia_fonte:['Potência da Fonte','Potência da Fonte'],
    cabeamento_fonte:['Cabeamento','Fonte'],
    certificacoes_fonte:['Certificação','Fonte'],
    tipo_cooler:['Tipo','Cooler'],
    tamanho_cooler:['Tamanho','Cooler'],
    tamanho_watercooler:['Tamanho Water Cooler','Cooler'],
    kit_cooler:['Kit','Cooler'],
    tipo_placaderede:['Tipo','Placa de Rede'],
    socket_placaderede:['Socket','Placa de Rede'],
    switch_teclado_gamer:['Switch','Teclado Gamer'],
    caracteristicas_switch:['Características do Switch','Teclado Gamer'],
    tipo_de_teclado_gamer:['Tipo','Teclado Gamer'],
    tipo_de_conexao_gamer:['Tipo de Conexão','Periférico Gamer'],
    dpi_mouse_gamer:['DPI','Mouse Gamer'],
    som_surround_headset_gamer:['Som Surround','Headset Gamer'],
    cancelamento_de_ruido_headset_gamer:['Cancelamento de Ruído','Headset Gamer'],
    apoio_de_braco_cadeira:['Apoio de Braço','Cadeira Gamer'],
    ajuste_encosto_cadeira:['Ajuste de Encosto','Cadeira Gamer'],
    capacidade_cadeira:['Capacidade','Cadeira Gamer'],
    tipo_de_suporte_gamer:['Tipo','Suporte Gamer'],
    tipo_teclado_perifericos:['Tipo','Teclado'],
    dpi_mouse_periferico:['DPI','Mouse'],
    apoio_de_pulso_mousepad:['Apoio de Pulso','Mousepad'],
    tipo_fone_perifericos:['Tipo','Fone de Ouvido'],
    potencia_caixa_de_som:['Potência','Caixa de Som'],
    iluminacao_caixa_de_som:['Iluminação','Caixa de Som'],
    tipo_headset_telefonia:['Tipo','Headset Telefonia'],
    headset_telefonia_com_base:['Com Base','Headset Telefonia'],
    tipo_carregador_portateis:['Tipo','Carregador'],
    resolucao_webcam:['Resolução','Webcam'],
    alcance_apresentador_de_slide:['Alcance','Apresentador de Slide'],
    tipo_pendrive_cartadememoria:['Tipo','Pendrive / Cartão'],
    capacidade_pendrive_cartaodememoria:['Capacidade','Pendrive / Cartão'],
    pendrive_tematico:['Temático','Pendrive / Cartão'],
    cacidade_hdexterno:['Capacidade','HD Externo'],
    tipo_de_apoio_ergonomico:['Tipo','Apoio Ergonômico'],
    capacidade_mochila:['Capacidade','Mochila Notebook'],
    suporte_note_com_ventilador:['Com Ventilador','Suporte Notebook'],
    capacidade_suporte_notebook:['Capacidade','Suporte Notebook'],
    impressora_multifuncional:['Multifuncional','Impressora'],
    impressora_colorida:['Colorida','Impressora'],
    conexao_wireless_impressora:['Conexão Wireless','Impressora'],
    ciclo_mensal_max_impressoras:['Ciclo Mensal Máx.','Impressora'],
    tipo_impressora_termica:['Tipo Térmica','Impressora Térmica'],
    ciclo_diario_max_scanner:['Ciclo Diário Máx.','Scanner'],
    leitor_com_pedestal:['Com Pedestal','Scanner / Leitor'],
    tipo_software:['Tipo','Software'],
    tipo_de_telefone:['Tipo','Telefone'],
    nfc_smartwatch:['NFC','Smartwatch'],
    compatibilidade_smartwatch:['Compatibilidade','Smartwatch'],
    quantidade_mp_camera:['Megapixels','Câmera'],
    kit_camera_bolsa:['Kit com Bolsa','Câmera'],
    quantidade_de_fotos_instantaneas:['Qtd. Fotos por Filme','Câmera Instantânea'],
    tipo_camera_seguranca:['Tipo','Câmera de Segurança'],
    voltagem_entrada_nobreakseestabilizadores:['Voltagem de Entrada','Nobreak / Estabilizador'],
    voltagem_saida_nobreakseestabilizadores:['Voltagem de Saída','Nobreak / Estabilizador'],
    capacidade_va_nobreakseestabilizadores:['Capacidade (VA)','Nobreak / Estabilizador'],
    tipo_bateria_nobreak:['Tipo de Bateria','Nobreak / Estabilizador'],
    ampera_bateria:['Amperagem','Nobreak / Estabilizador'],
    quantidade_tomada_filtrodelinha:['Qtd. Tomadas','Filtro de Linha'],
    tipo_pilha:['Tipo','Pilhas e Baterias'],
    kit_pilha:['Kit','Pilhas e Baterias'],
    tipo_tintaecartucho:['Tipo','Tinta / Cartucho'],
    tipo_ribon:['Tipo de Ribbon','Ribbon'],
    tipo_papel:['Tipo de Papel','Papel'],
    tamanho_tela_monitor:['Tamanho da Tela','Monitor'],
    resolucao_monitor:['Resolução','Monitor'],
    frequencia_monitor:['Frequência (Hz)','Monitor'],
    tela_curva_monitor:['Tela Curva','Monitor'],
    tipo_suporte_monitor:['Tipo de Suporte','Monitor'],
    suporte_articulado_monitor:['Suporte Articulado','Monitor'],
    compatibilidade_suporte_monitor:['Compat. Suporte','Monitor'],
    quantidade_lumens_projetor:['Lumens','Projetor'],
    tipo_alarme:['Tipo','Alarme'],
    tipo_grill:['Tipo','Grill'],
    tipo_ferrodepassar:['Tipo','Ferro de Passar'],
    capacidade_liquidificador:['Capacidade','Liquidificador'],
    tipo_processadordealimentos:['Tipo','Processador de Alimentos'],
    tipo_mixer:['Tipo','Mixer'],
    capacidade_fritadeira:['Capacidade','Fritadeira'],
    tipo_panelaeletrica:['Tipo','Panela Elétrica'],
    quantidade_pas_ventilador:['Qtd. Pás','Ventilador'],
    tipo_aspirador:['Tipo','Aspirador'],
    kit_abridorvinho:['Kit','Abridor de Vinho'],
    tipo_panela:['Tipo','Panelas'],
    material_panela:['Material','Panelas'],
    revestimento_panela:['Revestimento','Panelas'],
    quantidade_itens_jogodepanela:['Qtd. Itens','Jogo de Panelas'],
    tipo_lixeira:['Tipo','Lixeira'],
    quantidade_litros_lixeira:['Capacidade (L)','Lixeira'],
    quantidade_litros_tanque_cubas_pias:['Capacidade (L)','Pias / Tanques'],
    acabamento_cubas_pias:['Acabamento','Pias / Tanques'],
    tamanho_bandeja:['Tamanho','Bandeja'],
    tipo_faca:['Tipo','Facas'],
    tamanho_faca:['Tamanho','Facas'],
    quantidade_pecas_faqueiro:['Qtd. Peças','Faqueiro'],
    tipo_assadeira:['Tipo','Assadeiras'],
    tamanho_assadeira:['Tamanho','Assadeiras'],
    kit_assadeiras:['Kit','Assadeiras'],
    tipo_organizacao:['Tipo','Organização'],
    dualband_roteador:['Dual Band','Roteador'],
    taxa_sinal_roteador:['Taxa de Sinal','Roteador'],
    gigabit_roteador:['Gigabit','Roteador'],
    tipo_repetidor:['Tipo','Repetidor de Sinal'],
    quantidade_portausb_hub:['Qtd. Portas USB','Hub USB'],
    quantidade_portas_switch:['Qtd. Portas','Switch de Rede'],
    porta_ethernet_hub:['Porta Ethernet','Hub / Switch'],
    cadeiradepraia_reclinavel:['Reclinável','Cadeira de Praia'],
    tipo_apple:['Tipo','Produtos Apple'],
    tipo_estante:['Tipo','Estante'],
    tipo_cabodiversos:['Tipo','Cabos'],
    tipo_copo:['Tipo','Copo'],
    gaveta_dinheiro_automatica:['Automática','Gaveta de Dinheiro'],
    tamanho:['Tamanho','Geral'],
  };

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function boolDisp(v) {
    var s = String(v);
    return (s === 'true' || s === 'Sim') ? 'Sim' : (s === 'false' || s === 'Não') ? 'Não' : null;
  }

  function toDisp(val) {
    if (val === null || val === undefined || val === '') return null;
    var b = boolDisp(val);
    if (b) return b;
    var s = String(val).trim();
    return s || null;
  }

  /** Extrai polegadas do título (ex.: 21,5" / 24 polegadas) quando o metafield estiver vazio. */
  function parseMonitorSize(text) {
    if (!text) return null;
    var t = String(text)
      .replace(/[\u2018\u2019\u201A\u2032\u00B4`?]/g, '"')
      .replace(/['']{2}|″|''/g, '"');
    var m = t.match(/(\d{1,2}(?:[.,]\d)?)\s*(?:pol(?:egadas?)?|"|″)/i);
    if (!m) return null;
    return m[1].replace('.', ',') + '"';
  }

  /** Normaliza resolução a partir do título quando o metafield estiver vazio. */
  function parseMonitorResolution(text) {
    if (!text) return null;
    var t = String(text).toLowerCase();
    if (/\b(4k|uhd|ultra\s*hd)\b/.test(t)) return '4K';
    if (/\b(qhd|quad\s*hd|2k|1440p)\b/.test(t)) return 'QHD';
    if (/\b(full\s*hd|fullhd|fhd|1080p)\b/.test(t)) return 'Full HD';
    if (/\b(hd|720p)\b/.test(t)) return 'HD';
    return null;
  }

  function enrichMonitorMeta(p) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    var title = p.title || '';
    if (!toDisp(p.meta.tamanho_tela_monitor)) {
      var size = parseMonitorSize(title);
      if (size) p.meta.tamanho_tela_monitor = size;
    } else {
      // Normaliza "21.5" / "21,5 polegadas" → "21,5\""
      var normSize = parseMonitorSize(String(p.meta.tamanho_tela_monitor));
      if (normSize) p.meta.tamanho_tela_monitor = normSize;
    }
    if (!toDisp(p.meta.resolucao_monitor)) {
      var res = parseMonitorResolution(title);
      if (res) p.meta.resolucao_monitor = res;
    } else {
      var normRes = parseMonitorResolution(String(p.meta.resolucao_monitor));
      if (normRes) p.meta.resolucao_monitor = normRes;
    }
  }

  var GAMER_COLLECTIONS = {
    'gamer': 1,
    'mouse-gamer': 1,
    'teclado-gamer': 1,
    'kit-teclado-e-mouse-gamer': 1,
    'headset-gamer': 1,
    'microfone-de-mesa-gamer': 1
  };

  // Com Fio / Sem Fio / Gamer só nestas collections (e variações gamer)
  // Inclui 1º nível do menu: perifericos / gamer / audio (herança via cols do produto)
  var CONEXAO_COLLECTIONS = {
    'mouse': 1,
    'mouse-gamer': 1,
    'teclado': 1,
    'teclado-gamer': 1,
    'kit-teclado-e-mouse': 1,
    'kit-teclado-e-mouse-gamer': 1,
    'fone-de-ouvido': 1,
    'headset': 1,
    'headset-gamer': 1,
    'headset-telefonia': 1,
    'microfone': 1,
    'microfone-de-mesa': 1,
    'microfone-de-mesa-gamer': 1
  };

  var RAM_COLLECTIONS = {
    'memoria-ram': 1,
    'memoria': 1
  };

  var STORAGE_COLLECTIONS = {
    'ssd': 1,
    'hd': 1,
    'hd-externo': 1,
    'ssd-externo': 1
  };

  var PENDRIVE_COLLECTIONS = {
    'pen-drive-e-cartao-de-memoria': 1,
    'pen-drive': 1,
    'pendrive': 1,
    'cartao-de-memoria': 1
  };

  var FONTE_COLLECTIONS = {
    'fonte': 1
  };

  var CPU_COLLECTIONS = {
    'processador': 1,
    'processadores': 1
  };

  var PLACAMAE_COLLECTIONS = {
    'placa-mae': 1,
    'placas-mae': 1
  };

  var GPU_COLLECTIONS = {
    'placa-de-video': 1,
    'placas-de-video': 1,
    'placa-de-video-gamer': 1
  };

  /**
   * Libera enrichment se a collection da página OU alguma collection do produto
   * estiver no mapa. Assim filtros do 2º nível do menu também aparecem no 1º
   * (ex.: hardware → processador/memoria-ram; perifericos → mouse/teclado).
   */
  function inCollectionMap(collectionHandle, p, map) {
    if (collectionHandle && map[collectionHandle]) return true;
    if (p && Array.isArray(p.cols)) {
      for (var i = 0; i < p.cols.length; i++) {
        if (p.cols[i] && map[p.cols[i]]) return true;
      }
    }
    return false;
  }

  /** Com Fio / Sem Fio a partir de título + descrição (ou metafield custom.conexao). */
  function normalizeConexaoText(text) {
    var t = String(text)
      .toLowerCase()
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&[a-z#0-9]+;/gi, ' ')
      .replace(/[\u00a0\u202f\u2007\u2060]/g, ' ');
    t = t.replace(/\bs\/fio\b/g, 'sem fio');
    t = t.replace(/\bsemfio\b/g, 'sem fio');
    t = t.replace(/\bcomfio\b/g, 'com fio');
    return t;
  }

  function hasWirelessSignal(t) {
    return (
      /sem[\s-]*fio/.test(t) ||
      /\bwireless\b/.test(t) ||
      /\bwi[\s-]*fi\b/.test(t) ||
      /\bwifi\b/.test(t) ||
      /\bbluetooth\b/.test(t) ||
      /\bbluethooth\b/.test(t) ||
      /\blightspeed\b/.test(t) ||
      /\bbt\b/.test(t) ||
      /2[\s.,]*4\s*(ghz|g\b)/.test(t) ||
      /\breceptor\b/.test(t) ||
      /\bdongle\b/.test(t) ||
      (/\bnano\b/.test(t) && /\b(usb|receptor|receiver)\b/.test(t)) ||
      /\bdual\s*mode\b/.test(t) ||
      /\bmultipoint\b/.test(t)
    );
  }

  /** Conexão com fio real (não dongle/receptor USB de periférico só wireless). */
  function hasWiredConnectionSignal(t) {
    if (/com[\s-]*fio|\bwired\b/.test(t)) return true;
    if (/usb[\s-]*com[\s-]*fio/.test(t)) return true;
    if (/conex[aã]o\s+usb/.test(t)) return true;
    if (/via\s+usb(?![\s-]*c\b)/.test(t)) return true;
    if (/modo\s+(com[\s-]*)?fio/.test(t)) return true;
    if (/\bcabo\s+usb\b/.test(t) && /conex/.test(t)) return true;
    return false;
  }

  function hasHybridExplicit(t) {
    return (
      /com\s*e\s*sem[\s-]*fio/.test(t) ||
      /com\s*\/\s*sem[\s-]*fio/.test(t) ||
      /sem\s*e\s*com[\s-]*fio/.test(t) ||
      /\bh[ií]brido\b/.test(t) ||
      /wired\s+and\s+wireless/.test(t) ||
      /wireless\s+and\s+wired/.test(t) ||
      /bluetooth\s+ou\s+conex/.test(t) ||
      /lightspeed[\s\S]{0,80}usb\s+com\s+fio/.test(t) ||
      /sem[\s-]*fio[\s\S]{0,80}(?:ou|e|tamb[eé]m)[\s\S]{0,40}(?:usb|com[\s-]*fio)/.test(t)
    );
  }

  /**
   * Detecta flags de conexão. Produtos híbridos (ex.: LIGHTSPEED + USB com fio)
   * retornam wired e wireless = true.
   */
  function detectConexao(text) {
    var out = { wireless: false, wired: false };
    if (!text) return out;
    var t = normalizeConexaoText(text);
    var wireless = hasWirelessSignal(t);
    var wiredConn = hasWiredConnectionSignal(t);
    var hybrid = hasHybridExplicit(t);

    // USB "nu" (sem USB-C) só conta como com fio se não for só wireless
    var tWired = t
      .replace(/usb[\s-]*c\b/g, ' ')
      .replace(/\busbc\b/g, ' ')
      .replace(/type[\s-]*c\b/g, ' ');
    var bareUsb = /\busb\b/.test(tWired);

    if (hybrid || (wireless && wiredConn)) {
      out.wireless = true;
      out.wired = true;
      return out;
    }
    if (wireless) {
      out.wireless = true;
      return out;
    }
    if (wiredConn || bareUsb) {
      out.wired = true;
    }
    return out;
  }

  /** Lista de valores de faceta: Com Fio e/ou Sem Fio. */
  function parseConexaoList(text) {
    var d = detectConexao(text);
    var list = [];
    if (d.wired) list.push('Com Fio');
    if (d.wireless) list.push('Sem Fio');
    return list;
  }

  /** @deprecated use parseConexaoList — mantido para normalização simples */
  function parseConexao(text) {
    var list = parseConexaoList(text);
    if (list.length === 2) return list;
    return list[0] || null;
  }

  function normalizeConexao(val) {
    if (val === null || val === undefined || val === '') return null;
    var list = conexaoToList(val);
    if (list.length === 2) return list;
    if (list.length === 1) return list[0];
    return null;
  }

  /** Normaliza metafield/string/array em lista Com Fio / Sem Fio. */
  function conexaoToList(val) {
    if (val === null || val === undefined || val === '') return [];
    if (Array.isArray(val)) {
      var fromArr = [];
      val.forEach(function(item) {
        parseConexaoList(String(item)).forEach(function(v) {
          if (fromArr.indexOf(v) < 0) fromArr.push(v);
        });
        var raw = String(item).trim();
        if ((raw === 'Com Fio' || raw === 'Sem Fio') && fromArr.indexOf(raw) < 0) fromArr.push(raw);
      });
      return fromArr;
    }
    if (typeof val === 'string' && val.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return conexaoToList(parsed);
      } catch (e) { /* ignore */ }
    }
    var s = String(val).trim();
    if (/com\s*e\s*sem[\s-]*fio|\bh[ií]brido\b/i.test(s)) return ['Com Fio', 'Sem Fio'];
    var fromParse = parseConexaoList(s);
    if (fromParse.length) return fromParse;
    if (s === 'Com Fio' || s === 'Sem Fio') return [s];
    return [];
  }

  /** Texto usado para inferir atributos: título + descrição (+ handle). */
  function productTextBlob(p) {
    if (!p) return '';
    return [p.title || '', p.handle || '', p.desc || '', p.description || ''].join(' ');
  }

  /** Gamer a partir do título/descrição, metafield custom.linha ou membership em collection gamer. */
  function parseLinhaGamer(p, collectionHandle) {
    if (collectionHandle && GAMER_COLLECTIONS[collectionHandle]) return 'Gamer';
    if (p && Array.isArray(p.cols)) {
      for (var i = 0; i < p.cols.length; i++) {
        if (GAMER_COLLECTIONS[p.cols[i]]) return 'Gamer';
      }
    }
    if (/\bgamer\b/i.test(productTextBlob(p))) return 'Gamer';
    return null;
  }

  function enrichPeripheralMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};

    // Fora das collections permitidas (página ou membership do produto), não expõe Com Fio / Sem Fio / Linha
    if (!inCollectionMap(collectionHandle, p, CONEXAO_COLLECTIONS)) {
      delete p.meta.conexao;
      delete p.meta.linha;
      return;
    }

    var blob = productTextBlob(p);
    var fromText = parseConexaoList(blob);
    var fromMeta = conexaoToList(p.meta.conexao);

    // Une texto + metafield; híbridos ficam com Com Fio e Sem Fio
    var merged = [];
    function pushUnique(v) {
      if (v && merged.indexOf(v) < 0) merged.push(v);
    }
    fromText.forEach(pushUnique);
    fromMeta.forEach(pushUnique);

    if (merged.length === 2) {
      p.meta.conexao = ['Com Fio', 'Sem Fio'];
    } else if (merged.length === 1) {
      p.meta.conexao = merged[0];
    } else {
      delete p.meta.conexao;
    }

    // Em collections já gamer, filtro "Gamer" não faz sentido
    if (GAMER_COLLECTIONS[collectionHandle]) {
      delete p.meta.linha;
      return;
    }

    var linhaRaw = toDisp(p.meta.linha);
    if (linhaRaw && /\bgamer\b/i.test(linhaRaw)) {
      p.meta.linha = 'Gamer';
    } else {
      var gamer = parseLinhaGamer(p, collectionHandle);
      if (gamer) p.meta.linha = gamer;
    }
  }

  function parseRamCapacity(text) {
    if (!text) return null;
    var m = String(text).match(/\b(\d+)\s*gb\b/i);
    if (!m) return null;
    return m[1] + ' GB';
  }

  function parseRamFrequency(text) {
    if (!text) return null;
    var t = String(text);
    // Ex.: 3200MHz, 3200 MHz, 5600 MT/s, DDR4-3200, DDR5 4800
    var m = t.match(/\b(\d{3,5})\s*(?:mhz|mt\/s)\b/i) ||
      t.match(/\bddr[345][- ](\d{3,5})\b/i);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    if (n < 1333 || n > 9000) return null;
    return n + ' MHz';
  }

  function parseRamDdrType(text) {
    if (!text) return null;
    var m = String(text).match(/\b(ddr[345])(?:[- ]?(\d))?/i);
    if (!m) return null;
    return m[1].toUpperCase();
  }

  /** Notebook (SODIMM) vs Desktop — sem sinal de notebook → Desktop. */
  function parseRamFormato(text) {
    if (!text) return 'Desktop';
    var t = String(text)
      .toLowerCase()
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&[a-z#0-9]+;/gi, ' ');

    if (
      /\bnotebook\b/.test(t) ||
      /\blaptop\b/.test(t) ||
      /\bnote[\s-]*book\b/.test(t) ||
      /\bso[\s-]*dimm\b/.test(t) ||
      /\bsodimm\b/.test(t)
    ) {
      return 'Notebook';
    }
    return 'Desktop';
  }

  function normalizeRamFormato(val) {
    if (val === null || val === undefined || val === '') return null;
    var parsed = parseRamFormato(String(val));
    if (parsed) return parsed;
    var raw = String(val).trim();
    if (/^notebook$/i.test(raw)) return 'Notebook';
    if (/^desktop$/i.test(raw)) return 'Desktop';
    return raw || null;
  }

  function parseStorageCapacity(text) {
    if (!text) return null;
    var m = String(text).match(/\b(\d+(?:[.,]\d+)?)\s*(tb|gb)\b/i);
    if (!m) return null;
    var raw = m[1].replace(',', '.');
    var unit = m[2].toUpperCase();
    var num = parseFloat(raw);
    if (!isFinite(num) || num <= 0) return null;
    if (unit === 'TB') {
      var tb = (Math.round(num * 10) / 10);
      return (String(tb).indexOf('.') >= 0 ? String(tb).replace('.', ',') : String(tb)) + ' TB';
    }
    return Math.round(num) + ' GB';
  }

  function enrichRamMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, RAM_COLLECTIONS)) {
      delete p.meta.capacidade_memoria;
      delete p.meta.frequencia_memoria;
      delete p.meta.tipo_memoria;
      delete p.meta.formato_memoria;
      return;
    }
    var blob = productTextBlob(p);

    if (!toDisp(p.meta.capacidade_memoria)) {
      var cap = parseRamCapacity(blob);
      if (cap) p.meta.capacidade_memoria = cap;
    } else {
      var normCap = parseRamCapacity(String(p.meta.capacidade_memoria));
      if (normCap) p.meta.capacidade_memoria = normCap;
    }

    if (!toDisp(p.meta.frequencia_memoria)) {
      var freq = parseRamFrequency(blob);
      if (freq) p.meta.frequencia_memoria = freq;
    } else {
      var normFreq = parseRamFrequency(String(p.meta.frequencia_memoria));
      if (normFreq) p.meta.frequencia_memoria = normFreq;
    }

    if (!toDisp(p.meta.tipo_memoria)) {
      var ddr = parseRamDdrType(blob);
      if (ddr) p.meta.tipo_memoria = ddr;
    } else {
      var normDdr = parseRamDdrType(String(p.meta.tipo_memoria));
      if (normDdr) p.meta.tipo_memoria = normDdr;
    }

    var fromMetaFmt = normalizeRamFormato(p.meta.formato_memoria);
    if (fromMetaFmt === 'Notebook' || parseRamFormato(blob) === 'Notebook') {
      p.meta.formato_memoria = 'Notebook';
    } else if (fromMetaFmt === 'Desktop') {
      p.meta.formato_memoria = 'Desktop';
    } else {
      p.meta.formato_memoria = parseRamFormato(blob);
    }
  }

  function enrichStorageMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, STORAGE_COLLECTIONS)) {
      delete p.meta.capacidade_hdessd;
      return;
    }
    var blob = productTextBlob(p);

    if (!toDisp(p.meta.capacidade_hdessd)) {
      var stor = parseStorageCapacity(blob);
      if (stor) p.meta.capacidade_hdessd = stor;
    } else {
      var normStor = parseStorageCapacity(String(p.meta.capacidade_hdessd));
      if (normStor) p.meta.capacidade_hdessd = normStor;
    }
  }

  function enrichPendriveMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, PENDRIVE_COLLECTIONS)) {
      delete p.meta.capacidade_pendrive_cartaodememoria;
      return;
    }
    var blob = productTextBlob(p);
    var key = 'capacidade_pendrive_cartaodememoria';

    if (!toDisp(p.meta[key])) {
      var cap = parseStorageCapacity(blob);
      if (cap) p.meta[key] = cap;
    } else {
      var normCap = parseStorageCapacity(String(p.meta[key]));
      if (normCap) p.meta[key] = normCap;
    }
  }

  /** Potência em W a partir de título/handle (ex.: 600W, 300 Watts, 1000 wats). */
  function parseFontePotencia(text) {
    if (!text) return null;
    var t = String(text);
    var m = t.match(/\b(\d{3,4})\s*(?:w(?:atts?|ats?)?)\b/i);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    if (n < 100 || n > 2000) return null;
    return n + ' W';
  }

  function enrichFonteMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, FONTE_COLLECTIONS)) {
      delete p.meta.potencia_fonte;
      return;
    }
    var blob = productTextBlob(p);

    if (!toDisp(p.meta.potencia_fonte)) {
      var pot = parseFontePotencia(blob);
      if (pot) p.meta.potencia_fonte = pot;
    } else {
      var normPot = parseFontePotencia(String(p.meta.potencia_fonte));
      if (normPot) {
        p.meta.potencia_fonte = normPot;
      } else {
        // Metafield só com número (ex.: "600")
        var onlyNum = String(p.meta.potencia_fonte).match(/\b(\d{3,4})\b/);
        if (onlyNum) {
          var n = parseInt(onlyNum[1], 10);
          if (n >= 100 && n <= 2000) p.meta.potencia_fonte = n + ' W';
        }
      }
    }
  }

  /** AMD / Intel a partir de título, handle ou vendor. */
  function parseCpuPlataforma(p) {
    var vendor = String((p && p.vendor) || '').toLowerCase();
    var blob = productTextBlob(p).toLowerCase();

    if (
      /\bamd\b/.test(blob) ||
      /\bryzen\b/.test(blob) ||
      /\bathlon\b/.test(blob) ||
      /\bthreadripper\b/.test(blob) ||
      /\bepyc\b/.test(blob) ||
      vendor === 'amd'
    ) {
      return 'AMD';
    }
    if (
      /\bintel\b/.test(blob) ||
      /\bceleron\b/.test(blob) ||
      /\bpentium\b/.test(blob) ||
      /\bxeon\b/.test(blob) ||
      /\bcore\s*i[3579]\b/.test(blob) ||
      /\bi[3579]-\d/.test(blob) ||
      vendor === 'intel' ||
      vendor === 'ibm'
    ) {
      return 'Intel';
    }
    return null;
  }

  /**
   * VGA integrado Sim/Não.
   * Texto explícito prevalece; senão heurística por sufixo de modelo.
   */
  function parseCpuVgaIntegrado(p) {
    var blob = productTextBlob(p)
      .toLowerCase()
      .replace(/<[^>]+>/g, ' ')
      .replace(/&[a-z#0-9]+;/gi, ' ');

    if (
      /sem\s+(placa\s+de\s+)?v[ií]deo\s+integrad/.test(blob) ||
      /sem\s+gr[aá]ficos?\s+integrad/.test(blob) ||
      /sem\s+vga\s+integrad/.test(blob) ||
      /n[aã]o\s+possui\s+gr[aá]fico/.test(blob) ||
      /requires?\s+discrete\s+graphics/.test(blob) ||
      /sem\s+gpu\s+integrad/.test(blob)
    ) {
      return 'Não';
    }
    if (
      /gr[aá]ficos?\s+integrad/.test(blob) ||
      /v[ií]deo\s+integrad/.test(blob) ||
      /vga\s+integrad/.test(blob) ||
      /\bigpu\b/.test(blob) ||
      /uhd\s+graphics/.test(blob) ||
      /intel\s*®?\s*uhd/.test(blob) ||
      /radeon\s+graphics/.test(blob) ||
      /gr[aá]ficos?\s+radeon/.test(blob)
    ) {
      return 'Sim';
    }

    // Intel: sufixo F / KF = sem iGPU
    var intelM = blob.match(/\bi[3579][-\s]?(\d{4,5})\s*([a-z]{0,4})\b/i);
    if (intelM) {
      var isuf = (intelM[2] || '').toLowerCase();
      if (/f/.test(isuf)) return 'Não';
      return 'Sim';
    }
    if (/\bxeon\b/.test(blob)) return 'Não';
    if (/\bceleron\b/.test(blob) || /\bpentium\b/.test(blob)) return 'Sim';

    // AMD: G / GT / GE = APU; série 7000+ costuma ter iGPU; demais desktop sem G = Não
    var amdM = blob.match(/\b(?:ryzen|athlon)\s*[3579]?\s*(\d{4})\s*([a-z]{0,6})\b/i);
    if (amdM && (/\bryzen\b/.test(blob) || /\bathlon\b/.test(blob) || /\bamd\b/.test(blob))) {
      var gen = parseInt(amdM[1], 10);
      var asuf = (amdM[2] || '').toLowerCase();
      if (/g/.test(asuf)) return 'Sim';
      if (/f/.test(asuf) && !/x3d/.test(asuf)) return 'Não';
      // Zen 4+ (7xxx / 8xxx / 9xxx) desktop: iGPU incluso
      if (gen >= 7000 && gen < 10000) return 'Sim';
      return 'Não';
    }

    return null;
  }

  function normalizeSimNao(val) {
    if (val === null || val === undefined || val === '') return null;
    var s = String(val).trim().toLowerCase();
    if (/^(sim|yes|true|1|com)$/.test(s)) return 'Sim';
    if (/^(n[aã]o|nao|no|false|0|sem)$/.test(s)) return 'Não';
    return null;
  }

  function enrichCpuMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, CPU_COLLECTIONS)) {
      delete p.meta.plataforma_processador;
      delete p.meta.vga_integrado_processador;
      return;
    }

    var platMeta = toDisp(p.meta.plataforma_processador);
    if (platMeta && /amd/i.test(platMeta)) {
      p.meta.plataforma_processador = 'AMD';
    } else if (platMeta && /intel/i.test(platMeta)) {
      p.meta.plataforma_processador = 'Intel';
    } else {
      var plat = parseCpuPlataforma(p);
      if (plat) p.meta.plataforma_processador = plat;
    }

    var vgaMeta = normalizeSimNao(p.meta.vga_integrado_processador);
    if (vgaMeta) {
      p.meta.vga_integrado_processador = vgaMeta;
    } else {
      var vga = parseCpuVgaIntegrado(p);
      if (vga) p.meta.vga_integrado_processador = vga;
    }
  }

  /** DDR3 / DDR4 / DDR5 para placa-mãe. */
  function parsePlacamaeDdr(text) {
    if (!text) return null;
    var t = String(text).toLowerCase();
    var m = t.match(/\bddr\s*([345])\b/i);
    if (!m) return null;
    return 'DDR' + m[1];
  }

  /** Formato: Mini ITX, Micro ATX, ATX, E-ATX, SSI… */
  function parsePlacamaeFormato(text) {
    if (!text) return null;
    var t = String(text)
      .toLowerCase()
      .replace(/<[^>]+>/g, ' ')
      .replace(/&[a-z#0-9]+;/gi, ' ');

    if (/\bssi\s*ceb\b/.test(t)) return 'SSI CEB';
    if (/\bssi\s*eeb\b/.test(t)) return 'SSI EEB';
    if (/\bmini[\s-]*itx\b/.test(t) || /\bmitx\b/.test(t)) return 'Mini ITX';
    if (/\be[\s-]*atx\b/.test(t) || /\beatx\b/.test(t) || /\bextended\s*atx\b/.test(t)) return 'E-ATX';
    if (
      /\bmicro[\s-]*atx\b/.test(t) ||
      /\bm[\s-]*atx\b/.test(t) ||
      /\bmatx\b/.test(t) ||
      /\bmicroatx\b/.test(t)
    ) {
      return 'Micro ATX';
    }

    // Sufixo M no chipset (H610M, B550M, B760M, A520M, Z790M) → Micro ATX
    if (/\b(?:h|b|z|x|a|q)\d{3}m\b/.test(t)) return 'Micro ATX';

    // Chipset sem M (Z790, B550…) → ATX padrão
    if (/\b(?:h|b|z|x|a|q)\d{3}(?!m)\b/.test(t)) return 'ATX';

    if (/\batx\b/.test(t)) return 'ATX';
    return null;
  }

  function enrichPlacamaeMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, PLACAMAE_COLLECTIONS)) {
      delete p.meta.ddr_placamae;
      delete p.meta.formato_placamae;
      return;
    }
    var blob = productTextBlob(p);

    var ddrMeta = parsePlacamaeDdr(String(p.meta.ddr_placamae || ''));
    if (ddrMeta) {
      p.meta.ddr_placamae = ddrMeta;
    } else {
      var ddr = parsePlacamaeDdr(blob);
      if (ddr) p.meta.ddr_placamae = ddr;
    }

    var fmtRaw = toDisp(p.meta.formato_placamae);
    var fmtMeta = fmtRaw ? parsePlacamaeFormato(fmtRaw) : null;
    if (fmtMeta) {
      p.meta.formato_placamae = fmtMeta;
    } else {
      var fmt = parsePlacamaeFormato(blob);
      if (fmt) p.meta.formato_placamae = fmt;
    }
  }

  /** NVIDIA / AMD/ATI / INTEL. */
  function parseGpuTipo(text) {
    if (!text) return null;
    var t = String(text).toLowerCase();

    if (
      /\bintel\b/.test(t) ||
      /\barc\s*a\d/.test(t) ||
      /\bintel\s*arc\b/.test(t)
    ) {
      return 'INTEL';
    }
    if (
      /\bamd\b/.test(t) ||
      /\bati\b/.test(t) ||
      /\bradeon\b/.test(t) ||
      /\brx\s*\d{3,4}\b/.test(t)
    ) {
      return 'AMD/ATI';
    }
    if (
      /\bnvidia\b/.test(t) ||
      /\bgeforce\b/.test(t) ||
      /\brtx\s*\d{3,4}\b/.test(t) ||
      /\bgtx\s*\d{3,4}\b/.test(t) ||
      /\bgt\s*\d{2,4}\b/.test(t) ||
      /\bquadro\b/.test(t) ||
      /\bnvs\b/.test(t) ||
      /\btesla\b/.test(t)
    ) {
      return 'NVIDIA';
    }
    return null;
  }

  /** VRAM: 2 GB, 6 GB, 8 GB… */
  function parseGpuVram(text) {
    if (!text) return null;
    var t = String(text);
    // Prioriza GB perto de GDDR / no início do título
    var m = t.match(/\b(\d{1,2})\s*gb\s*(?:gddr|ddr)?/i) ||
      t.match(/\b(\d{1,2})\s*gb\b/i);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    if (n < 1 || n > 48) return null;
    return n + ' GB';
  }

  /** GDDR6 / GDDR6X / GDDR7 / DDR3… */
  function parseGpuMemType(text) {
    if (!text) return null;
    var t = String(text).toLowerCase();
    // Ordem: variantes mais específicas primeiro (GDDR6X antes de GDDR6)
    if (/\bgddr\s*6\s*x\b/.test(t) || /\bgddr6x\b/.test(t)) return 'GDDR6X';
    if (/\bgddr\s*7\b/.test(t) || /\bgddr7\b/.test(t)) return 'GDDR7';
    if (/\bgddr\s*6\b/.test(t) || /\bgddr6\b/.test(t)) return 'GDDR6';
    if (/\bgddr\s*5\b/.test(t) || /\bgddr5\b/.test(t)) return 'GDDR5';
    if (/\bgddr\s*3\b/.test(t) || /\bgddr3\b/.test(t)) return 'GDDR3';
    if (/\bddr\s*3\b/.test(t) || /\bddr3\b/.test(t)) return 'DDR3';
    if (/\bddr\s*5\b/.test(t) || /\bddr5\b/.test(t)) return 'DDR5';
    if (/\bddr\s*4\b/.test(t) || /\bddr4\b/.test(t)) return 'DDR4';
    return null;
  }

  /** Modelo/série: RTX 3050, GT 710, RX 6600, Arc A750… */
  function parseGpuModelo(text) {
    if (!text) return null;
    var t = String(text);

    var m =
      t.match(/\b(rtx)\s*(\d{3,4})\s*(ti|super)?\b/i) ||
      t.match(/\b(gtx)\s*(\d{3,4})\s*(ti|super)?\b/i) ||
      t.match(/\b(gt)\s*(\d{2,4})\b/i) ||
      t.match(/\b(rx)\s*(\d{3,4})\s*(xt|gre)?\b/i) ||
      t.match(/\b(arc)\s*(a\d{3,4})\b/i) ||
      t.match(/\b(quadro)\s*([a-z]?\d{3,4})\b/i) ||
      t.match(/\b(nvs)\s*(\d{3,4})\b/i);

    if (!m) return null;
    var family = m[1].toUpperCase();
    var num = m[2].toUpperCase();
    var suf = (m[3] || '').toUpperCase();
    if (family === 'ARC') return 'Arc ' + num;
    var label = family + ' ' + num;
    if (suf) label += ' ' + suf;
    return label.replace(/\s+/g, ' ').trim();
  }

  function enrichGpuMeta(p, collectionHandle) {
    if (!p) return;
    if (!p.meta) p.meta = {};
    if (!inCollectionMap(collectionHandle, p, GPU_COLLECTIONS)) {
      delete p.meta.tipo_placadevideo;
      delete p.meta.modelo_placadevideo;
      delete p.meta.memoria_placadevideo;
      delete p.meta.gddr_placadevideo;
      return;
    }
    var blob = productTextBlob(p);

    var tipoMeta = toDisp(p.meta.tipo_placadevideo);
    if (tipoMeta) {
      var normTipo = parseGpuTipo(tipoMeta) || (
        /amd|ati|radeon/i.test(tipoMeta) ? 'AMD/ATI' :
        /intel/i.test(tipoMeta) ? 'INTEL' :
        /nvidia|geforce/i.test(tipoMeta) ? 'NVIDIA' : null
      );
      if (normTipo) p.meta.tipo_placadevideo = normTipo;
    } else {
      var tipo = parseGpuTipo(blob);
      if (tipo) p.meta.tipo_placadevideo = tipo;
    }

    if (!toDisp(p.meta.memoria_placadevideo)) {
      var vram = parseGpuVram(blob);
      if (vram) p.meta.memoria_placadevideo = vram;
    } else {
      var normVram = parseGpuVram(String(p.meta.memoria_placadevideo));
      if (normVram) p.meta.memoria_placadevideo = normVram;
    }

    if (!toDisp(p.meta.gddr_placadevideo)) {
      var gddr = parseGpuMemType(blob);
      if (gddr) p.meta.gddr_placadevideo = gddr;
    } else {
      var normGddr = parseGpuMemType(String(p.meta.gddr_placadevideo));
      if (normGddr) p.meta.gddr_placadevideo = normGddr;
    }

    if (!toDisp(p.meta.modelo_placadevideo)) {
      var modelo = parseGpuModelo(blob);
      if (modelo) p.meta.modelo_placadevideo = modelo;
    } else {
      var normMod = parseGpuModelo(String(p.meta.modelo_placadevideo));
      if (normMod) p.meta.modelo_placadevideo = normMod;
    }
  }

  function sizeSortKey(label) {
    var m = String(label).match(/(\d+)(?:[.,](\d+))?/);
    if (!m) return 0;
    return parseFloat(m[1] + '.' + (m[2] || '0'), 10);
  }

  function storageSortKey(label) {
    var m = String(label).match(/(\d+(?:[.,]\d+)?)\s*(tb|gb)/i);
    if (!m) return 0;
    var n = parseFloat(m[1].replace(',', '.'));
    if (/tb/i.test(m[2])) n *= 1024;
    return n;
  }

  function sortFacetVals(key, valKeys) {
    if (key === 'tamanho_tela_monitor') {
      return valKeys.slice().sort(function(a, b) { return sizeSortKey(a) - sizeSortKey(b); });
    }
    if (key === 'capacidade_hdessd' || key === 'capacidade_memoria' || key === 'capacidade_pendrive_cartaodememoria') {
      return valKeys.slice().sort(function(a, b) { return storageSortKey(a) - storageSortKey(b); });
    }
    if (key === 'frequencia_memoria') {
      return valKeys.slice().sort(function(a, b) { return sizeSortKey(a) - sizeSortKey(b); });
    }
    if (key === 'potencia_fonte') {
      return valKeys.slice().sort(function(a, b) { return sizeSortKey(a) - sizeSortKey(b); });
    }
    if (key === 'conexao') {
      var order = { 'Com Fio': 0, 'Sem Fio': 1 };
      return valKeys.slice().sort(function(a, b) {
        var oa = order.hasOwnProperty(a) ? order[a] : 50;
        var ob = order.hasOwnProperty(b) ? order[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'linha') {
      var orderL = { 'Gamer': 0 };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderL.hasOwnProperty(a) ? orderL[a] : 50;
        var ob = orderL.hasOwnProperty(b) ? orderL[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'formato_memoria') {
      var orderF = { 'Notebook': 0, 'Desktop': 1 };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderF.hasOwnProperty(a) ? orderF[a] : 50;
        var ob = orderF.hasOwnProperty(b) ? orderF[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'plataforma_processador') {
      var orderP = { 'AMD': 0, 'Intel': 1 };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderP.hasOwnProperty(a) ? orderP[a] : 50;
        var ob = orderP.hasOwnProperty(b) ? orderP[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'vga_integrado_processador') {
      var orderV = { 'Sim': 0, 'Não': 1 };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderV.hasOwnProperty(a) ? orderV[a] : 50;
        var ob = orderV.hasOwnProperty(b) ? orderV[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'ddr_placamae') {
      var orderD = { 'DDR3': 0, 'DDR4': 1, 'DDR5': 2 };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderD.hasOwnProperty(a) ? orderD[a] : 50;
        var ob = orderD.hasOwnProperty(b) ? orderD[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'formato_placamae') {
      var orderFmt = {
        'Mini ITX': 0,
        'Micro ATX': 1,
        'ATX': 2,
        'E-ATX': 3,
        'SSI CEB': 4,
        'SSI EEB': 5
      };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderFmt.hasOwnProperty(a) ? orderFmt[a] : 50;
        var ob = orderFmt.hasOwnProperty(b) ? orderFmt[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'tipo_placadevideo') {
      var orderGpu = { 'AMD/ATI': 0, 'NVIDIA': 1, 'INTEL': 2 };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderGpu.hasOwnProperty(a) ? orderGpu[a] : 50;
        var ob = orderGpu.hasOwnProperty(b) ? orderGpu[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'memoria_placadevideo') {
      return valKeys.slice().sort(function(a, b) { return storageSortKey(a) - storageSortKey(b); });
    }
    if (key === 'modelo_placadevideo') {
      return valKeys.slice().sort(function(a, b) { return a.localeCompare(b, 'pt-BR', { numeric: true }); });
    }
    if (key === 'gddr_placadevideo') {
      var orderGddr = {
        'DDR3': 0, 'DDR4': 1, 'DDR5': 2,
        'GDDR3': 3, 'GDDR5': 4, 'GDDR6': 5, 'GDDR6X': 6, 'GDDR7': 7
      };
      return valKeys.slice().sort(function(a, b) {
        var oa = orderGddr.hasOwnProperty(a) ? orderGddr[a] : 50;
        var ob = orderGddr.hasOwnProperty(b) ? orderGddr[b] : 50;
        if (oa !== ob) return oa - ob;
        return a.localeCompare(b, 'pt-BR');
      });
    }
    if (key === 'tipo_memoria') {
      return valKeys.slice().sort(function(a, b) { return a.localeCompare(b, 'pt-BR'); });
    }
    return valKeys.slice().sort(function(a, b) { return a.localeCompare(b, 'pt-BR'); });
  }

  function esc(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/"/g,'&quot;')
      .replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  }

  var CHEVRON = '<svg class="collection-page__filter-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
  var CHECK_SVG = '<svg width="9" height="7" viewBox="0 0 9 7" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 3.5 3.5 6 8 1"/></svg>';

  // ─── DOM refs ─────────────────────────────────────────────────────────────
  var filterRoot    = document.getElementById('syma-filters-root');
  var filterDataEl  = document.getElementById('syma-filter-data');
  var grid          = document.getElementById('collection-grid');
  var countEl       = document.getElementById('collection-product-count');
  var activeFiltersEl = document.getElementById('syma-active-filters');

  if (!filterDataEl || !filterRoot || !grid) return;

  var collectionHandle = (grid.dataset.collectionHandle || filterRoot.dataset.collectionHandle || '').trim();

  // ─── Parse product data ───────────────────────────────────────────────────
  var products;
  try { products = JSON.parse(filterDataEl.textContent); }
  catch (e) { console.warn('[Syma Filters] Erro ao parsear dados.', e); return; }

  if (!Array.isArray(products)) products = [];

  function enrichProduct(p) {
    enrichMonitorMeta(p);
    enrichPeripheralMeta(p, collectionHandle);
    enrichRamMeta(p, collectionHandle);
    enrichStorageMeta(p, collectionHandle);
    enrichPendriveMeta(p, collectionHandle);
    enrichFonteMeta(p, collectionHandle);
    enrichCpuMeta(p, collectionHandle);
    enrichPlacamaeMeta(p, collectionHandle);
    enrichGpuMeta(p, collectionHandle);
  }

  products.forEach(enrichProduct);

  // ─── Price bounds ─────────────────────────────────────────────────────────
  var priceAbsMin = 0;
  var priceAbsMax = 0;
  var hasPriceRange = false;
  if (products.length) {
    var rawPrices = products.map(function(p) { return typeof p.price === 'number' ? p.price : 0; });
    priceAbsMin = Math.floor(Math.min.apply(null, rawPrices) / 100) * 100;
    priceAbsMax = Math.ceil(Math.max.apply(null, rawPrices) / 100) * 100;
    hasPriceRange = priceAbsMax > priceAbsMin;
  }

  // ─── Brand (vendor) facet — always shown ──────────────────────────────────
  var vendorMap = {};
  products.forEach(function(p) {
    var v = p.vendor;
    if (!v || !String(v).trim()) return;
    var vt = String(v).trim();
    vendorMap[vt] = (vendorMap[vt] || 0) + 1;
  });
  var vendorVals = Object.keys(vendorMap)
    .sort(function(a, b) { return a.localeCompare(b, 'pt-BR'); })
    .map(function(v) { return [v, vendorMap[v]]; });

  // ─── Metafield facets ─────────────────────────────────────────────────────
  var facets = {};
  var groups = {};
  var groupNames = [];

  function rebuildMetaFacets() {
    facets = {};
    products.forEach(function(p) {
      var meta = p.meta || {};
      Object.keys(meta).forEach(function(key) {
        var disps;
        if (key === 'conexao') {
          disps = conexaoToList(meta[key]);
        } else {
          var d = toDisp(meta[key]);
          disps = d ? [d] : [];
        }
        disps.forEach(function(disp) {
          if (!facets[key]) facets[key] = {};
          facets[key][disp] = (facets[key][disp] || 0) + 1;
        });
      });
    });

    groups = {};
    Object.keys(facets).forEach(function(key) {
      var valKeys = Object.keys(facets[key]);
      // Linha (Gamer) e Tipo GPU podem ter 1 valor; demais facetas precisam de ≥2 opções
      if (key === 'linha' || key === 'tipo_placadevideo') {
        if (valKeys.length < 1) return;
      } else if (valKeys.length < 2) {
        return;
      }
      var info = META[key];
      if (!info) return;
      var label = info[0], group = info[1];
      if (!groups[group]) groups[group] = [];
      var vals = sortFacetVals(key, valKeys).map(function(v) { return [v, facets[key][v]]; });
      groups[group].push({ key: key, label: label, vals: vals });
    });

    // Em Tipo: Conexão antes de Linha
    if (groups['Tipo']) {
      groups['Tipo'].sort(function(a, b) {
        var order = { conexao: 0, linha: 1 };
        var oa = order.hasOwnProperty(a.key) ? order[a.key] : 50;
        var ob = order.hasOwnProperty(b.key) ? order[b.key] : 50;
        return oa - ob;
      });
    }

    // Memória RAM: quantidade → frequência → tipo DDR
    if (groups['Memória RAM']) {
      groups['Memória RAM'].sort(function(a, b) {
        var order = { capacidade_memoria: 0, frequencia_memoria: 1, tipo_memoria: 2, formato_memoria: 3 };
        var oa = order.hasOwnProperty(a.key) ? order[a.key] : 50;
        var ob = order.hasOwnProperty(b.key) ? order[b.key] : 50;
        return oa - ob;
      });
    }

    // Placa de Vídeo: modelo → VRAM
    if (groups['Placa de Vídeo']) {
      groups['Placa de Vídeo'].sort(function(a, b) {
        var order = { modelo_placadevideo: 0, memoria_placadevideo: 1, gddr_placadevideo: 2, chipset_placadevideo: 3 };
        var oa = order.hasOwnProperty(a.key) ? order[a.key] : 50;
        var ob = order.hasOwnProperty(b.key) ? order[b.key] : 50;
        return oa - ob;
      });
    }

    groupNames = Object.keys(groups).sort(function(a, b) {
      // Grupos de atributo no topo (já renderizam antes de Marca)
      var prio = {
        Monitor: 0,
        Tipo: 0,
        'Memória RAM': 0,
        Armazenamento: 0,
        'Pendrive / Cartão': 0,
        'Potência da Fonte': 0,
        Plataforma: 0,
        'VGA Integrado': 0,
        'Tipo de Memória': 0,
        'Formato da Placa': 1,
        'Tipo Placa de Vídeo': 0,
        'Placa de Vídeo': 1
      };
      var oa = prio.hasOwnProperty(a) ? prio[a] : 10;
      var ob = prio.hasOwnProperty(b) ? prio[b] : 10;
      if (oa !== ob) return oa - ob;
      return a.localeCompare(b, 'pt-BR');
    });
  }

  rebuildMetaFacets();

  // ─── URL helpers ──────────────────────────────────────────────────────────
  function getActive() {
    var params = new URLSearchParams(location.search);
    var active = {};
    params.forEach(function(v, k) {
      if (k.indexOf(P) !== 0) return;
      var mk = k.slice(P.length);
      if (mk === 'price_min' || mk === 'price_max') return;
      if (!active[mk]) active[mk] = [];
      active[mk].push(v);
    });
    return active;
  }

  function getPriceActive() {
    var params = new URLSearchParams(location.search);
    var minStr = params.get(P + 'price_min');
    var maxStr = params.get(P + 'price_max');
    var minParsed = minStr !== null ? parseInt(minStr, 10) : NaN;
    var maxParsed = maxStr !== null ? parseInt(maxStr, 10) : NaN;
    var hasMin = !isNaN(minParsed);
    var hasMax = !isNaN(maxParsed);
    if (!hasMin && !hasMax) return null;
    return {
      min: hasMin ? minParsed : priceFillMin,
      max: hasMax ? maxParsed : priceFillMax
    };
  }

  function buildUrl(active, priceMin, priceMax) {
    var params = new URLSearchParams(location.search);
    var toDelete = [];
    params.forEach(function(_, k) { if (k.indexOf(P) === 0) toDelete.push(k); });
    toDelete.forEach(function(k) { params.delete(k); });
    // Filtrar sempre volta para página 1 (evita ?page= legado inválido)
    params.delete('page');
    Object.keys(active).forEach(function(mk) {
      active[mk].forEach(function(v) { params.append(P + mk, v); });
    });
    if (typeof priceMin === 'number' && typeof priceMax === 'number' &&
        !isNaN(priceMin) && !isNaN(priceMax) &&
        (priceMin > priceAbsMin || priceMax < priceAbsMax)) {
      params.set(P + 'price_min', priceMin);
      params.set(P + 'price_max', priceMax);
    }
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function toggleVal(active, key, disp) {
    var newActive = {};
    Object.keys(active).forEach(function(k) { newActive[k] = active[k].slice(); });
    if (!newActive[key]) newActive[key] = [];
    var idx = newActive[key].indexOf(disp);
    if (idx >= 0) {
      newActive[key].splice(idx, 1);
      if (!newActive[key].length) delete newActive[key];
    } else {
      newActive[key].push(disp);
    }
    return newActive;
  }

  // ─── Render helpers ───────────────────────────────────────────────────────
  function checkboxItem(disp, cnt, isActive, url) {
    return '<li class="collection-page__filter-item">' +
      '<button type="button" class="collection-page__filter-link' +
      (isActive ? ' collection-page__filter-link--active' : '') +
      '" data-filter-url="' + esc(url) + '">' +
      '<span class="collection-page__filter-check' +
      (isActive ? ' collection-page__filter-check--checked' : '') +
      '" aria-hidden="true">' + CHECK_SVG + '</span>' +
      '<span class="collection-page__filter-link-label">' + esc(disp) + '</span>' +
      '<span class="collection-page__filter-count">(' + cnt + ')</span>' +
      '</button></li>';
  }

  function groupWrapper(title, badgeCount, inner, openByDefault) {
    var badge = badgeCount
      ? '<span class="collection-page__filter-badge">' + badgeCount + '</span>'
      : '';
    return '<details class="collection-page__filter-group"' + (openByDefault ? ' open' : '') + '>' +
      '<summary class="collection-page__filter-toggle">' +
      '<span class="collection-page__filter-toggle-label">' + esc(title) + badge + '</span>' +
      CHEVRON + '</summary>' +
      '<div class="collection-page__filter-body">' + inner + '</div>' +
      '</details>';
  }

  // ─── Render: brand group ──────────────────────────────────────────────────
  function renderBrandGroup(active, priceActive) {
    if (!vendorVals.length) return '';
    var activeVals = active['vendor'] || [];
    var priceMin = priceActive ? priceActive.min : undefined;
    var priceMax = priceActive ? priceActive.max : undefined;
    var inner = '<ul class="collection-page__filter-list">';
    vendorVals.forEach(function(pair) {
      var disp = pair[0], cnt = pair[1];
      var isActive = activeVals.indexOf(disp) >= 0;
      var url = buildUrl(toggleVal(active, 'vendor', disp), priceMin, priceMax);
      inner += checkboxItem(disp, cnt, isActive, url);
    });
    inner += '</ul>';
    return groupWrapper('Marca', activeVals.length, inner, true);
  }

  // ─── Render: price group ──────────────────────────────────────────────────
  function isPriceUiReady() {
    var serverPages = parseInt(grid.dataset.serverPages || '1', 10);
    return serverPages <= 1 || grid.dataset.gridReady === '1';
  }

  function renderPriceGroup(active, priceActive) {
    if (!hasPriceRange) return '';
    var curMin = priceActive ? priceActive.min : priceAbsMin;
    var curMax = priceActive ? priceActive.max : priceAbsMax;
    var priceReady = isPriceUiReady();
    var disabledAttr = priceReady ? '' : ' disabled';
    var inner =
      '<div class="collection-page__price-form' + (priceReady ? '' : ' collection-page__price-form--disabled') + '" data-price-filter' +
      ' data-price-abs-min="' + priceAbsMin + '" data-price-abs-max="' + priceAbsMax + '">' +
      '<div class="collection-page__price-values">' +
      '<span data-price-min-display>' + esc(formatMoney(curMin)) + '</span>' +
      '<span class="collection-page__price-sep">—</span>' +
      '<span data-price-max-display>' + esc(formatMoney(curMax)) + '</span>' +
      '</div>' +
      '<div class="collection-page__price-range-wrap">' +
      '<span class="collection-page__price-fill" data-price-fill></span>' +
      '<input type="range" class="collection-page__price-slider" data-price-slider-min' +
      ' min="' + priceAbsMin + '" max="' + priceAbsMax + '" step="100" value="' + curMin + '"' + disabledAttr + '>' +
      '<input type="range" class="collection-page__price-slider" data-price-slider-max' +
      ' min="' + priceAbsMin + '" max="' + priceAbsMax + '" step="100" value="' + curMax + '"' + disabledAttr + '>' +
      '</div>' +
      '<button type="button" class="collection-page__price-apply" data-price-apply' +
      (priceReady ? '' : ' disabled aria-disabled="true"') +
      '>Aplicar</button>' +
      '</div>';
    return groupWrapper('Faixa de Preço', priceActive ? 1 : 0, inner, true);
  }

  // ─── Render: metafield groups ─────────────────────────────────────────────
  function renderMetaGroups(active, priceActive) {
    var html = '';
    var priceMin = priceActive ? priceActive.min : undefined;
    var priceMax = priceActive ? priceActive.max : undefined;
    groupNames.forEach(function(gname) {
      var items = groups[gname];
      var totalActive = items.reduce(function(n, item) {
        return n + (active[item.key] ? active[item.key].length : 0);
      }, 0);
      var inner = '';
      // Tipo / Potência / Plataforma / VGA: lista plana (sem sublabel)
      if (
        gname === 'Tipo' ||
        gname === 'Potência da Fonte' ||
        gname === 'Plataforma' ||
        gname === 'VGA Integrado' ||
        gname === 'Tipo de Memória' ||
        gname === 'Formato da Placa' ||
        gname === 'Tipo Placa de Vídeo'
      ) {
        inner += '<ul class="collection-page__filter-list">';
        items.forEach(function(item) {
          var activeVals = active[item.key] || [];
          item.vals.forEach(function(pair) {
            var disp = pair[0], cnt = pair[1];
            var isActive = activeVals.indexOf(disp) >= 0;
            var url = buildUrl(toggleVal(active, item.key, disp), priceMin, priceMax);
            inner += checkboxItem(disp, cnt, isActive, url);
          });
        });
        inner += '</ul>';
      } else {
        items.forEach(function(item) {
          var activeVals = active[item.key] || [];
          inner += '<p class="syma-filter-attr-label">' + esc(item.label) + '</p>' +
                   '<ul class="collection-page__filter-list">';
          item.vals.forEach(function(pair) {
            var disp = pair[0], cnt = pair[1];
            var isActive = activeVals.indexOf(disp) >= 0;
            var url = buildUrl(toggleVal(active, item.key, disp), priceMin, priceMax);
            inner += checkboxItem(disp, cnt, isActive, url);
          });
          inner += '</ul>';
        });
      }
      html += groupWrapper(
        gname,
        totalActive,
        inner,
        gname === 'Monitor' ||
          gname === 'Tipo' ||
          gname === 'Memória RAM' ||
          gname === 'Armazenamento' ||
          gname === 'Pendrive / Cartão' ||
          gname === 'Potência da Fonte' ||
          gname === 'Plataforma' ||
          gname === 'VGA Integrado' ||
          gname === 'Tipo de Memória' ||
          gname === 'Formato da Placa' ||
          gname === 'Tipo Placa de Vídeo' ||
          gname === 'Placa de Vídeo'
      );
    });
    return html;
  }

  // ─── Init price slider ────────────────────────────────────────────────────
  function initPriceSlider(active, priceActive) {
    var form = filterRoot.querySelector('[data-price-filter]');
    if (!form) return;
    var minSlider  = form.querySelector('[data-price-slider-min]');
    var maxSlider  = form.querySelector('[data-price-slider-max]');
    var minDisplay = form.querySelector('[data-price-min-display]');
    var maxDisplay = form.querySelector('[data-price-max-display]');
    var fill       = form.querySelector('[data-price-fill]');
    var applyBtn   = form.querySelector('[data-price-apply]');
    var absMin     = parseInt(form.dataset.priceAbsMin, 10);
    var absMax     = parseInt(form.dataset.priceAbsMax, 10);
    var range      = absMax - absMin;

    function updateTrack() {
      if (!fill || !range) return;
      var leftPct  = ((parseInt(minSlider.value, 10) - absMin) / range) * 100;
      var rightPct = 100 - ((parseInt(maxSlider.value, 10) - absMin) / range) * 100;
      fill.style.left  = leftPct + '%';
      fill.style.right = rightPct + '%';
    }

    function updateDisplays() {
      if (minDisplay) minDisplay.textContent = formatMoney(parseInt(minSlider.value, 10));
      if (maxDisplay) maxDisplay.textContent = formatMoney(parseInt(maxSlider.value, 10));
      updateTrack();
    }

    minSlider.addEventListener('input', function() {
      if (parseInt(this.value, 10) > parseInt(maxSlider.value, 10)) maxSlider.value = this.value;
      updateDisplays();
    });

    maxSlider.addEventListener('input', function() {
      if (parseInt(this.value, 10) < parseInt(minSlider.value, 10)) minSlider.value = this.value;
      updateDisplays();
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        window.location.href = buildUrl(active,
          parseInt(minSlider.value, 10),
          parseInt(maxSlider.value, 10));
      });
    }

    updateTrack();
  }

  // ─── Render sidebar ───────────────────────────────────────────────────────
  function render() {
    var active      = getActive();
    var priceActive = getPriceActive();
    var hasAny      = vendorVals.length || hasPriceRange || groupNames.length;

    if (!hasAny) {
      filterRoot.innerHTML = '<p class="collection-page__filter-empty">Nenhum filtro disponível para esta coleção.</p>';
      renderChips(active, priceActive);
      return;
    }

    var html = '';
    html += renderMetaGroups(active, priceActive);
    html += renderBrandGroup(active, priceActive);
    html += renderPriceGroup(active, priceActive);

    var hasActive = Object.keys(active).length > 0 || !!priceActive;
    if (hasActive) {
      html +=
        '<div class="collection-page__filter-footer">' +
        '<button type="button" class="collection-page__filter-clear-btn" data-clear-all>' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        ' Limpar filtros</button></div>';
    }

    filterRoot.innerHTML = html;
    initPriceSlider(active, priceActive);
    renderChips(active, priceActive);
  }

  // ─── Active chips ─────────────────────────────────────────────────────────
  function renderChips(active, priceActive) {
    if (!activeFiltersEl) return;
    var hasActive = Object.keys(active).length > 0 || !!priceActive;
    if (!hasActive) {
      activeFiltersEl.innerHTML = '';
      activeFiltersEl.style.display = 'none';
      return;
    }
    activeFiltersEl.style.display = '';
    var pMin = priceActive ? priceActive.min : undefined;
    var pMax = priceActive ? priceActive.max : undefined;
    var html = '';

    // Vendor chips
    if (active['vendor']) {
      active['vendor'].forEach(function(v) {
        var url = buildUrl(toggleVal(active, 'vendor', v), pMin, pMax);
        html += chipBtn('Marca: ' + v, url);
      });
    }

    // Price chip
    if (priceActive) {
      var clearPriceUrl = buildUrl(active);
      html += chipBtn('Preço: ' + formatMoney(priceActive.min) + ' — ' + formatMoney(priceActive.max), clearPriceUrl);
    }

    // Metafield chips
    Object.keys(active).forEach(function(key) {
      if (key === 'vendor') return;
      var label = META[key] ? META[key][0] : key;
      active[key].forEach(function(v) {
        var url = buildUrl(toggleVal(active, key, v), pMin, pMax);
        html += chipBtn(label + ': ' + v, url);
      });
    });

    html += '<button type="button" class="collection-page__active-chip collection-page__active-chip--clear" data-clear-all>Limpar tudo</button>';
    activeFiltersEl.innerHTML = html;
  }

  function chipBtn(text, url) {
    return '<button type="button" class="collection-page__active-chip" data-filter-url="' + esc(url) + '">' +
      esc(text) +
      '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button>';
  }

  // ─── Apply filters to grid ────────────────────────────────────────────────
  function apply() {
    var active      = getActive();
    var priceActive = getPriceActive();
    var hasFilters  = Object.keys(active).length > 0 || !!priceActive;
    var items       = grid.querySelectorAll('[data-product-id]');
    var visible     = 0;

    items.forEach(function(li) {
      var pid   = parseInt(li.dataset.productId, 10);
      var pdata = null;
      for (var i = 0; i < products.length; i++) {
        if (products[i].id === pid) { pdata = products[i]; break; }
      }
      var matches = true;

      if (hasFilters) {
        if (!pdata) {
          // Produto sem dados carregados ainda — exclui provisoriamente;
          // será reavaliado quando syma:products-extended chegar.
          matches = false;
        } else {
          // Price range
          if (priceActive) {
            var price = typeof pdata.price === 'number' ? pdata.price : 0;
            if (price < priceActive.min || price > priceActive.max) matches = false;
          }

          if (matches) {
            var activeKeys = Object.keys(active);
            for (var ki = 0; ki < activeKeys.length; ki++) {
              var key = activeKeys[ki];
              var raw;
              if (key === 'vendor') {
                raw = pdata.vendor ? String(pdata.vendor).trim() : '';
                if (!raw) { matches = false; break; }
                if (active[key].indexOf(raw) < 0) { matches = false; break; }
              } else if (key === 'conexao') {
                raw = pdata.meta ? pdata.meta[key] : undefined;
                var conexDisps = conexaoToList(raw);
                if (!conexDisps.length) { matches = false; break; }
                var conexHit = false;
                for (var ci = 0; ci < active[key].length; ci++) {
                  if (conexDisps.indexOf(active[key][ci]) >= 0) { conexHit = true; break; }
                }
                if (!conexHit) { matches = false; break; }
              } else {
                raw = pdata.meta ? pdata.meta[key] : undefined;
                if (!raw && raw !== 0) { matches = false; break; }
                var disp = toDisp(raw);
                if (!disp) { matches = false; break; }
                if (active[key].indexOf(disp) < 0) { matches = false; break; }
              }
            }
          }
        }
      }

      li.dataset.filterMatch = matches ? '1' : '0';
      li.style.display = matches ? '' : 'none';
      if (matches) visible++;
    });

    if (countEl) {
      countEl.textContent = visible + ' produto' + (visible !== 1 ? 's' : '') +
        ' encontrado' + (visible !== 1 ? 's' : '');
    }

    grid.dispatchEvent(new CustomEvent('syma:filter-applied', { detail: { count: visible } }));
  }

  // ─── Events ───────────────────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-filter-url]');
    if (btn) {
      e.preventDefault();
      history.pushState({}, '', btn.dataset.filterUrl);
      render(); apply();
      return;
    }
    var clearBtn = e.target.closest('[data-clear-all]');
    if (clearBtn) {
      e.preventDefault();
      // Preserva sort_by; remove filtros e page
      var params = new URLSearchParams(location.search);
      var sortBy = params.get('sort_by');
      var next = new URLSearchParams();
      if (sortBy) next.set('sort_by', sortBy);
      var qs = next.toString();
      history.pushState({}, '', location.pathname + (qs ? '?' + qs : ''));
      render(); apply();
    }
  });

  window.addEventListener('popstate', function() { render(); apply(); });

  // ─── Produtos extras de server-pages 2, 3… ────────────────────────────────
  // Quando o inline JS terminar de buscar as demais páginas, ele dispara este
  // evento com os dados de produtos adicionais.
  grid.addEventListener('syma:products-extended', function(e) {
    var extra = e.detail;
    if (!Array.isArray(extra)) return;
    var seenIds = {};
    products.forEach(function(p0) {
      if (p0 && p0.id != null) seenIds[p0.id] = 1;
    });
    extra.forEach(function(p) {
      if (!p || p.id == null || seenIds[p.id]) return;
      seenIds[p.id] = 1;
      enrichProduct(p);
      products.push(p);
    });

    // Recalcula bounds de preço com todos os produtos
    if (products.length) {
      var newPrices = products.map(function(p2) { return typeof p2.price === 'number' ? p2.price : 0; });
      priceAbsMin = Math.floor(Math.min.apply(null, newPrices) / 100) * 100;
      priceAbsMax = Math.ceil(Math.max.apply(null, newPrices) / 100) * 100;
      hasPriceRange = priceAbsMax > priceAbsMin;
    }

    // Recalcula facets de vendor
    vendorMap = {};
    products.forEach(function(p2) {
      var v = p2.vendor;
      if (!v || !String(v).trim()) return;
      var vt = String(v).trim();
      vendorMap[vt] = (vendorMap[vt] || 0) + 1;
    });
    vendorVals = Object.keys(vendorMap)
      .sort(function(a, b) { return a.localeCompare(b, 'pt-BR'); })
      .map(function(v) { return [v, vendorMap[v]]; });

    // Recalcula facetas de metafields (inclui tamanho/resolução derivados do título)
    rebuildMetaFacets();

    // Reaplica filtros com dados completos
    render();
    apply();
  });

  if (parseInt(grid.dataset.serverPages || '1', 10) > 1 && grid.dataset.gridReady !== '1') {
    grid.addEventListener('grid:ready', function() {
      render();
      apply();
    }, { once: true });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  render();
  apply();

})();
